import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { Subscription } from 'rxjs/internal/Subscription';
import { BasketDecorator } from '../../../customer/api/basket/basket.decorator';
import { ActionComponent } from '../../../ui/api/action.component';

@Component({
    selector: 'basket-oos-items-warning',
    templateUrl: './basket-oos-items-warning.html',
    styleUrl: './basket-oos-items-warning.scss',
    standalone: true,
    imports: [ActionComponent, CommonModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketOosItemsWarningComponent implements OnInit, OnDestroy {
    protected subscription = new Subscription();

    @Input()
    status = new Status();

    constructor(
        private cd: ChangeDetectorRef,
        private app: App
    ) {}

    ngOnInit(): void {
        this.subscription.add(this.status.subscribe(() => this.cd.detectChanges()));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    get basket(): BasketDecorator {
        return <BasketDecorator>this.app.customer.basket;
    }

    removeOOSProducts(): void {
        this.basket.removeOOSProducts(this.status);
    }
}
